(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('spec-form');
    var container = document.getElementById('downloads');
    if (!container) return;

    var pdfSpec = container.getAttribute('data-spec-url') || '';
    var pdfClearance = container.getAttribute('data-clearance-url') || '';
    var productUrl = container.getAttribute('data-product-url') || '';

    // ---------------- helpers ----------------
    function getChoicesFromForm() {
      if (!form) return [];
      return Array.prototype.slice.call(
        form.querySelectorAll('input[name="download_choice"]:checked')
      ).map(function(cb){ return cb.value; });
    }

    function buildPayload(choices) {
      return {
        choices: choices,
        spec: pdfSpec,
        clearance: pdfClearance,
        productUrl: productUrl,
        ts: Date.now()
      };
    }

    function savePayload(d) {
      try {
        localStorage.setItem('aristore_dl', JSON.stringify(d));
        localStorage.setItem('aristore_dl_backup', JSON.stringify(d)); // safety net
      } catch (err) {}
    }

    function openFromPayload(d, preferNewTab) {
      if (!d) return false;

      var first = null, opened = 0;
      function openTab(u){
        if (!u) return;
        if (!first) first = u;
        var w = preferNewTab ? window.open(u, '_blank') : null;
        if (w) opened++;
      }

      var choices = Array.isArray(d.choices) ? d.choices : [];
      var wantsSpecs = choices.indexOf('specs') >= 0 || choices.indexOf('both') >= 0;
      var wantsClear = choices.indexOf('clearance') >= 0 || choices.indexOf('both') >= 0;
      var wantsBoth  = wantsSpecs && wantsClear;

      if (wantsSpecs && d.spec) openTab(d.spec);
      if (wantsClear && d.clearance) openTab(d.clearance);

      // choose first available if none opened yet
      if (!first) first = d.spec || d.clearance || null;

      // Fallbacks:
      if (opened === 0) {
        if (wantsBoth && d.spec && d.clearance) {
          // popup blocked & two docs: show inline panel with links
          showInlinePanel(d);
          return true;
        }
        if (first) {
          window.location.replace(first); // single doc or only one available
          return true;
        }
      }
      return opened > 0;
    }

    function showInlinePanel(d) {
      var host = document.getElementById('downloads') || document.body;
      var box = document.createElement('div');
      box.setAttribute('role','status');
      box.style = 'margin:16px 0;padding:14px 16px;border:1px solid #CFC4C3;border-radius:12px;background:#faf8f7';
      var h = document.createElement('div');
      h.style = 'font-weight:600;margin-bottom:8px';
      h.textContent = 'Your downloads are ready:';
      box.appendChild(h);
      if (d.spec) {
        var a1 = document.createElement('a');
        a1.href = d.spec; a1.target = '_blank'; a1.rel = 'noopener';
        a1.textContent = 'Open Specifications PDF';
        box.appendChild(a1); box.appendChild(document.createElement('br'));
      }
      if (d.clearance) {
        var a2 = document.createElement('a');
        a2.href = d.clearance; a2.target = '_blank'; a2.rel = 'noopener';
        a2.textContent = 'Open Clearance Installation Manual';
        box.appendChild(a2);
      }
      host.prepend(box);
      try { host.scrollIntoView({behavior:'smooth', block:'start'}); } catch(_){}
    }

    function recently(tsMs, minutes) {
      var maxAge = (minutes || 15) * 60 * 1000;
      return typeof tsMs === 'number' && (Date.now() - tsMs) < maxAge;
    }

    // ---------------- submit: save + set pending flag ----------------
    if (form) {
      var isPreview = /(?:^|[?&])preview_theme_id=/.test(window.location.search);
      form.addEventListener('submit', function(e) {
        if (!form.checkValidity()) { form.reportValidity(); e.preventDefault(); return; }

        var anyAvailable = !!(pdfSpec || pdfClearance);
        var choices = getChoicesFromForm();
        if (anyAvailable && choices.length === 0) { alert('Please select at least one document.'); e.preventDefault(); return; }

        var payload = buildPayload(choices);
        savePayload(payload);
        sessionStorage.setItem('aristore_dl_pending', '1'); // <-- key change

        // In preview, open immediately too (but still submit)
        if (isPreview && anyAvailable) {
          openFromPayload(payload, true);
        }
        // allow native submit
      });
    }

    // ---------------- opener on return load ----------------
    // Trigger open if any of these are true:
    // - we came back with ?contact_posted=true
    // - URL has #spec-form
    // - we previously set the pending flag (covers /challenge → back to product)
    var params = new URLSearchParams(window.location.search);
    var hash = (window.location.hash || '').toLowerCase();
    var cameBackFlag = params.get('contact_posted') === 'true';
    var anchoredToForm = hash.includes('spec-form');
    var pending = sessionStorage.getItem('aristore_dl_pending') === '1';

    if (cameBackFlag || anchoredToForm || pending) {
      var data = null, raw = localStorage.getItem('aristore_dl');
      if (raw) { try { data = JSON.parse(raw); } catch(e) {} }
      if (!data) {
        var raw2 = localStorage.getItem('aristore_dl_backup');
        if (raw2) { try { data = JSON.parse(raw2); } catch(e) {} }
      }

      if (data && (!data.ts || recently(data.ts, 15))) {
        openFromPayload(data, true);
      }

      // Clean query so refresh doesn’t retrigger
      try {
        if (cameBackFlag) {
          params.delete('contact_posted');
          var clean = window.location.pathname + (params.toString() ? ('?' + params.toString()) : '') + window.location.hash;
          window.history.replaceState({}, '', clean);
        }
      } catch (e) {}

      // Clear guards/payload
      sessionStorage.removeItem('aristore_dl_pending');
      try { localStorage.removeItem('aristore_dl'); } catch(_) {}
      // keep backup briefly for debugging if needed
    }
  });
})();
